import React from 'react';
import config from '../utils/config';
import { useNavigate, useLocation } from 'react-router-dom';

export default function OrderSuccess() {
  const navigate  = useNavigate();
  const { state } = useLocation();
  const order     = state?.order;

  return (
    <div className="page-enter" style={{ textAlign: 'center', padding: '80px 24px', maxWidth: 600, margin: '0 auto' }}>
      <div style={{ fontSize: 64, marginBottom: 24 }}>✅</div>
      <h1 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: 40, fontWeight: 300, marginBottom: 12 }}>
        Order Placed!
      </h1>
      <p style={{ fontSize: 15, color: 'var(--text-mid)', marginBottom: 32 }}>
        Thank you for shopping with Anvith Dazzle. Your order has been confirmed.
      </p>
      <div style={{ background: 'var(--cream)', border: '1px solid var(--border)', borderRadius: 4, padding: 24, marginBottom: 32, textAlign: 'left' }}>
        {order?.orderId && (
          <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 14 }}>
            <span style={{ color: 'var(--text-light)' }}>Order ID</span>
            <span style={{ fontWeight: 500 }}>{order.orderId}</span>
          </div>
        )}
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid var(--border)', fontSize: 14 }}>
          <span style={{ color: 'var(--text-light)' }}>Estimated Delivery</span>
          <span style={{ fontWeight: 500 }}>5–7 Business Days</span>
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', fontSize: 14 }}>
          <span style={{ color: 'var(--text-light)' }}>Status</span>
          <span style={{ fontWeight: 500, color: 'green' }}>Confirmed ✓</span>
        </div>
        <div style={{ background: '#F0F8F0', color: '#2E7D32', padding: 12, borderRadius: 2, fontSize: 13, marginTop: 16 }}>
          📱 Order confirmation sent to your mobile / email
        </div>
      </div>
      <div style={{ display: 'flex', gap: 12, justifyContent: 'center', flexWrap: 'wrap' }}>
        <button className="btn btn-primary btn-lg" onClick={() => navigate('/')}>Continue Shopping</button>
        <a href="{config.whatsappUrl(config.whatsappOrderQuery)}"
           target="_blank" rel="noreferrer"
           className="btn btn-whatsapp btn-lg" style={{ textDecoration: 'none' }}>
          💬 WhatsApp Us
        </a>
      </div>
    </div>
  );
}
